// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__B5ozp","signatureButtonsRight":"ModalSign_signatureButtonsRight__35YO0"};